import { render, staticRenderFns } from "./BeneficiaryDiedYN.vue?vue&type=template&id=45c68407"
import script from "./BeneficiaryDiedYN.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDiedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports